import queryString from "query-string";

import {
    GET_ROLE_COMPETENCIES,
    GET_ROLE_COMPETENCY_BY_ID,
    CREATE_ROLE_COMPETENCY,
    UPDATE_ROLE_COMPETENCY,
    DELETE_ROLE_COMPETENCY
} from "@/api/master-data/role-competency/role-competency";

const state = {
    roleCompetencies: [],
    roleCompetency: {},
    totalItems: 0,
    loading: false
};

const mutations = {
    setRoleCompetencies: (state, payload) => {
        state.roleCompetencies = payload.data || [];
        state.totalItems = payload.totalItems || 0;
    },
    setRoleCompetency: (state, payload) => {
        state.roleCompetency = payload;
    },
    setLoading: (state, loading) => {
        state.loading = loading;
    }
};

const actions = {
    // Get all role competencies
    getRoleCompetencies: async ({ commit }, args) => {
        const params = queryString.stringify(args);
        commit('setLoading', true);
        
        try {
            const resp = await GET_ROLE_COMPETENCIES(params);
            if (resp.data.httpCode === 200) {
                commit("setRoleCompetencies", resp.data.data);
                return resp.data.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp && resp.data && resp.data.httpCode === 404) {
                commit("setRoleCompetencies", { data: [], totalItems: 0 });
            }
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },

    // Get role competency by ID
    getRoleCompetencyById: async ({ commit }, id) => {
        commit('setLoading', true);
        
        try {
            const resp = await GET_ROLE_COMPETENCY_BY_ID(id);
            if (resp.data.httpCode === 200) {
                commit("setRoleCompetency", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },

    // Create role competency
    createRoleCompetency: async ({ commit }, data) => {
        commit('setLoading', true);
        
        try {
            const resp = await CREATE_ROLE_COMPETENCY(data);
            return resp.data;
        } catch (err) {
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },

    // Update role competency
    updateRoleCompetency: async ({ commit }, { id, data }) => {
        commit('setLoading', true);
        
        try {
            const resp = await UPDATE_ROLE_COMPETENCY(id, data);
            return resp.data;
        } catch (err) {
            throw err;
        } finally {
            commit('setLoading', false);
        }
    },

    // Delete role competency
    deleteRoleCompetency: async ({ commit }, id) => {
        commit('setLoading', true);
        
        try {
            const resp = await DELETE_ROLE_COMPETENCY(id);
            return resp.data;
        } catch (err) {
            throw err;
        } finally {
            commit('setLoading', false);
        }
    }
};

const getters = {
    getRoleCompetencies: (state) => state.roleCompetencies,
    getRoleCompetency: (state) => state.roleCompetency,
    getTotalItems: (state) => state.totalItems,
    getLoading: (state) => state.loading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};